import React from 'react';
import { NavLink } from 'react-router-dom';
import SsaCover from '../../images/SSACoverMay2017.jpg';

const HomePageNews = () => {
    return (
        <section className="container news">
            <h2>News</h2>
            <p>I'm happy to announce I'm the cover artist of the May issue of <a href="http://community.saa.co.uk/paintmagazine/">SAA Paint magazine</a>. Please note the phone number was misprinted, refer to my <NavLink to="/contact">contact page</NavLink> for more info.</p>
            <div className="text-center">
                <a href="http://community.saa.co.uk/paintmagazine/"><img alt="SAA Paint Magazine May 2017 Cover" src={SsaCover} /></a>
            </div>
        </section>
    );
};

export default HomePageNews;



// WEBPACK FOOTER //
// ./src/components/homePage/HomePageNews.js